import BaseViewModel from '../../../infraestructure/BaseViewModel'

export default class MainMenuViewModel extends BaseViewModel {
  constructor (view) {
    super(view)
  }
  
  getPermissions(){
    
  }

  bindMainMenu() {
    var tid = setInterval( function () {
      if ( document.readyState !== 'complete' ) return;
      clearInterval( tid );
    
    
      var nav = document.querySelector('.vertical_nav');
      var wrapper = document.querySelector('.wrapper');
      var toggleMenu = document.querySelector('.toggle_menu');
      var collapseMenu = document.querySelector('.collapse_menu');
      var menu = document.getElementById("js-menu");
      var subnavs = menu ? menu.querySelectorAll('.menu--item__has_sub_menu') : [];    
    
      // Toggle menu click
      if (toggleMenu) {
        toggleMenu.onclick = function () {
          if (nav) nav.classList.toggle('vertical_nav__opened');
          if (wrapper) wrapper.classList.toggle('toggle-content');
        };
      }
    
      // Minify menu on menu_minifier click
      if (collapseMenu) {
        collapseMenu.onclick = function () {
          if (nav) nav.classList.toggle('vertical_nav__minify');
          if (wrapper) wrapper.classList.toggle('wrapper__minify');
    
          for (var j = 0; j < subnavs.length; j++) {
            subnavs[j].classList.remove('menu--subitens__opened');
          }
        };
      }
    
      // Open Sub Menu
      for (var i = 0; i < subnavs.length; i++) {
        
        if (subnavs[i].classList.contains('menu--item__has_sub_menu') ) {
          
          var menuLink = subnavs[i].querySelector('.menu--link');
          if (menuLink) {
            menuLink.addEventListener('click', function (e) {
    
                for (var j = 0; j < subnavs.length; j++) {
    
                  if(e.target.offsetParent != subnavs[j])
                    subnavs[j].classList.remove('menu--subitens__opened');          
    
                }
    
                if(e.target.offsetParent)
                  e.target.offsetParent.classList.toggle('menu--subitens__opened');
    
            }, false);
          }
        }
      }
    
    
    }, 100 );
  }
}